import React from 'react';

const AccessContext = React.createContext({
    canDisplayCountryFlags: () => false,
    canManageRecipientSchedule: () => false,
    canManageInternalConferenceResponse: () => false,
    canManageFollowUps: () => false,
    canManageSmsOptIn: () => false,
    canManageCascadeNotifications: () => false,
    canManageEmailAttachment: () => false,
    canManageSMSSegments: () => false,
    canManageTwitter: () => false,
    canManageScenarioLibrary: () => false,
    canViewMFA: () => false,
    canViewAdvancedContactsFilter: () => false,
    canViewAdvancedGroupFilter: () => false,
    canManageIntegrations: () => false,
    canManageFacebook: () => false,
    canManageSlack: () => false,
    canManageMSTeams: () => false,
    canWebInitiationNotification: () => false,
    canOrganizationAdmin: () => false,
    canSendFromShowAll: () => false,
    canViewGroups: () => false,
    canViewContacts: () => false,
    canViewSchedules: () => false,
    canCreateGroups: () => false,
    canEditContacts: () => false,
    canCreateSchedule: () => false,
    canAssignSchedule: () => false,
    canDeleteSchedule: () => false,
    canEditSchedule: () => false,
    canViewSchedule: () => false,
    canDeleteGroup: () => false,
    canManageSelfRegPortals: () => false,
    canCreateContact: () => false,
    canDeleteContact: () => false,
    canGrantLoginAccess: () => false,
    canImportContacts: () => false,
    canExportContacts: () => false,
    canViewAlertOptions: () => false,
    canViewLabels: () => false,
    canViewDataHierarchy: () => false,
    canViewUsers: () => false,
    canViewRoles: () => false,
    canEditRoles: () => false,
    canViewCustomVerbiage: () => false,
    canViewGeneralOptions: () => false,
    canViewRetrySettings: () => false,
    canViewPriority: () => false,
    canViewEmail: () => false,
    canViewSMS: () => false,
    canViewVoice: () => false,
    canViewProtectedDataFields: () => false,
    canViewDataSubjectRights: () => false,
    canViewCallThrottling: () => false,
    canViewDivisionANI: () => false,
    canViewAlertRetrieval: () => false,
    canViewAllowedSMS: () => false,
    canViewDuplicateFilters: () => false,
    canViewAssignSmsProfiles: () => false,
    canViewManageBlockedSMS: () => false,
    canViewEditTSSVoices: () => false,
    canViewSuppressedAlert: () => false,
    canViewManageDivisionSMIMEKeys: () => false,
    canViewMoveDivisions: () => false,
    canViewUsersNew: () => false,
    canViewLookOut: () => false,
    canViewSOS: () => false,
    canEditLookOut: () => false,
    canEditSOS: () => false,
    canAllowPrivateAddressTypes: () => false,
    canEditNotification: () => false,
    canViewNotification: () => false,
    canCreateNotification: () => false,
    canDeleteNotification: () => false,
    canInitiateNotification: () => false,
    canViewAlertInbox: () => false,
    canViewAlerts: () => false,
    canViewScheduledAlerts: () => false,
    canViewBulkAlerts: () => false,
    canEditPronunciation: () => false,
    canViewScenarioLibrary: () => false,
    canViewAPIKeys: () => false,
    canEditIncident: () => false,
    canViewAdHocReports: () => false,
    canViewAlertHistory: () => false,
    canViewAuditTrail: () => false,
    canViewCustomReports: () => false,
    canViewReporting: () => false,
    canViewShapesLibrary: () => false,
    canViewUsage: () => false,
    canViewTopics: () => false,
    canViewWeatherAndEvents: () => false,

    canEditTopic: () => false,
    canViewMyProfile: () => false,
    canManageMFASettings: () => false,
    canViewAnnouncementsTool: () => false,
    canViewAnnouncements: () => false,
    canCheckIn: () => true,
    canViewAudit: () => false,
    canConfigureTwitter: () => false,
    canEditTwitter: () => false,
    canUseTwitter: () => false,
    canViewTwitter: () => false,
    canManageDoNotContact: () => false,
    canEditDoNotContact: () => false,
    canViewDoNotContact: () => false,
    canDeleteDoNotContact: () => false,
    canCreateDoNotContact: () => false,
    canManageExternalLinks: () => false,
    canViewExternalLinks: () => false,
    canViewOpV3: () => false,
    canManageRiskIntelligenceDivisionSync: () => false,
    canViewDivisionBoundaries: () => false,
    canViewBillingUsage: () => false,
    canViewPeopleOverTime: () => false,
    canManagaeIpaws: () => false,
    canInitiateIpaws: () => false,
    usesNextGenSendingEngine : () => false,
    canViewPredefinedLocations: () => false,
    canViewIntegration: () => false
});

export const AccessConsumer = AccessContext.Consumer;
export default AccessContext;



